import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'CANCELLATION_POLICY' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/cancellation-policy/handlers.js